module.exports = __webpack_public_path__ + "img/farewell_15.bc37be22.jpg";